import React from 'react';
import { useSelector } from 'react-redux';
import { Row } from 'react-grid-system';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import useTranslate from '@Utils/hooks/useTranslate';
import { ICartItem, IInsuranceCartItem } from '@ApiModels/viewCart';
import PageContent from './PageContent';
import AddressOptions from './AddressOptions';
import PickupInformation from './PickupInformation';
import { SelectedAddressType } from '../ShippingMethod';
import { ShippingInfoLabelWrapper } from './../ShippingMethod.styled';

interface IAddressBookAvailable {
	addressType: SelectedAddressType;
	differentAddress: () => JSX.Element;
	hbbWfbbItem: ICartItem | IInsuranceCartItem | undefined;
	hasDeviceWithHbbWfbbItem: boolean | undefined;
	isPrepaidPurchase: boolean | undefined;
	launchDate: string | undefined;
	pickupSelector: JSX.Element;
	setAddressType: (type: SelectedAddressType) => void;
}

const AddressBookAvailable = ({
	addressType,
	differentAddress,
	hbbWfbbItem,
	hasDeviceWithHbbWfbbItem,
	isPrepaidPurchase,
	launchDate,
	pickupSelector,
	setAddressType,
}: IAddressBookAvailable): JSX.Element => {
	const { translate } = useTranslate();
	const newAddressBook = useSelector((state: types.redux.IState) => state.addressBook.newAddressBook);

	return (
		<>
			<Row>{!hbbWfbbItem && pickupSelector}</Row>
			<ConditionalRender
				show={addressType === SelectedAddressType.PICKUP}
				onTrue={() => <PickupInformation launchDate={launchDate} />}
				onFalse={() => (
					<ConditionalRender
						show={addressType !== SelectedAddressType.OUTLET}
						onTrue={() => (
							<>
								<ConditionalRender
									show={addressType !== SelectedAddressType.DIFFERENT || !!newAddressBook}
									onTrue={() => (
										<ShippingInfoLabelWrapper>
											<PageContent
												title={translate('shipping-method.deliver.address.title')}
												description={translate(
													'shipping-method.deliver.address.label-subtitle'
												)}
												name={!!hasDeviceWithHbbWfbbItem ? 'deliveryBus' : 'location'}
												withoutChild={true}
											/>
										</ShippingInfoLabelWrapper>
									)}
								/>
								<AddressOptions
									addressType={addressType}
									isPrepaidPurchase={isPrepaidPurchase}
									differentAddress={differentAddress}
									setAddressType={setAddressType}
								/>
							</>
						)}
					/>
				)}
			/>
		</>
	);
};

export default AddressBookAvailable;
